import type {
  AnnotatedJsonSchema,
  RelationshipArrayDataSchema,
} from '@web-config-app/core';

export const isRelationshipArrayDataSchema = (
  dataSchema: AnnotatedJsonSchema | RelationshipArrayDataSchema | undefined,
): dataSchema is RelationshipArrayDataSchema => Boolean(dataSchema?.items);
